import { FlowRouter } from "meteor/ostrio:flow-router-extra";
import { Meteor } from "meteor/meteor";
import { setCurrentRoute } from "../../ui/state/router";

function setRoute(name, path, params = {}, queryParams = {}) {
    setCurrentRoute({
        name,
        path,
        params,
        queryParams,
    });
}

function requireAdmin(context, redirect) {
    if (!Meteor.userId()) {
        redirect("/login");
    }
}

FlowRouter.route("/", {
    name: "home",
    action(params, queryParams) {
        setRoute("home", "/", params, queryParams);
    },
});

FlowRouter.route("/vehicles", {
    name: "vehicles",
    action(params, queryParams) {
        setRoute("vehicles", "/vehicles", params, queryParams);
    },
});

FlowRouter.route("/vehicles/:inventoryId", {
    name: "vehicle-details",
    action(params, queryParams) {
        setRoute(
            "vehicle-details",
            `/vehicles/${params.inventoryId}`,
            params,
            queryParams,
        );
    },
});

FlowRouter.route("/financing", {
    name: "financing",
    action(params, queryParams) {
        setRoute("financing", "/financing", params, queryParams);
    },
});

FlowRouter.route("/application", {
    name: "application",
    action(params, queryParams) {
        setRoute("application", "/application", params, queryParams);
    },
});

FlowRouter.route("/about", {
    name: "about",
    action(params, queryParams) {
        setRoute("about", "/about", params, queryParams);
    },
});

FlowRouter.route("/testimonials", {
    name: "testimonials",
    action(params, queryParams) {
        setRoute("testimonials", "/testimonials", params, queryParams);
    },
});

FlowRouter.route("/contact", {
    name: "contact",
    action(params, queryParams) {
        setRoute("contact", "/contact", params, queryParams);
    },
});

FlowRouter.route("/login", {
    name: "login",
    action(params, queryParams) {
        setRoute("login", "/login", params, queryParams);
    },
});

FlowRouter.route("/mgmt", {
    name: "mgmt",
    triggersEnter: [requireAdmin],
    action() {
        FlowRouter.go("/mgmt/inventory");
    },
});

FlowRouter.route("/mgmt/inventory", {
    name: "mgmt",
    triggersEnter: [requireAdmin],
    action(params, queryParams) {
        setRoute(
            "mgmt",
            "/mgmt/inventory",
            { ...params, section: "inventory" },
            queryParams,
        );
    },
});

FlowRouter.route("/mgmt/leads", {
    name: "mgmt",
    triggersEnter: [requireAdmin],
    action(params, queryParams) {
        setRoute(
            "mgmt",
            "/mgmt/leads",
            { ...params, section: "leads" },
            queryParams,
        );
    },
});

FlowRouter.route("/mgmt/applications", {
    name: "mgmt",
    triggersEnter: [requireAdmin],
    action(params, queryParams) {
        setRoute(
            "mgmt",
            "/mgmt/applications",
            { ...params, section: "applications" },
            queryParams,
        );
    },
});

FlowRouter.route("/mgmt/settings", {
    name: "mgmt-settings",
    triggersEnter: [requireAdmin],
    action(params, queryParams) {
        setRoute("mgmt-settings", "/mgmt/settings", params, queryParams);
    },
});

FlowRouter.notFound = {
    action() {
        setRoute("not-found", "/404");
    },
};
